export default __webpack_public_path__ + "static/media/confidence.855cf943.svg";